export default __webpack_public_path__ + "static/media/mail.9896b686.svg";